
(function(template){
define('vue!app/views/vue/components/cartComponent/cartBody/serviceBookDetails',['Vue','vuex','moment'],function(Vue,vuex,moment){
    return {
        template: template,
        data: function(){
            return {
                activeMethod: null
            }
        },
        computed: _.extend(vuex.mapState(['activeStep','users']),
            {
                options: function(){
                    var vm = this;
                    return Object.keys(this.users).filter(function(item){ return item != vm.userId });
                },
                dateString: function(){
                    return moment(this.date+this.service.time,'MMMM DD, YYYYhh:mm a').format(this.localStrings.sideCart.service.body.dateFormat);
                },
                serviceBooked: function(){
                    return !!this.service.SpaFolioItemId;
                }
            }
        ),
        props: ['service','class_name','date','staff','editing_this','userId'],
        methods:{
            handleDropdownItemClick: function(user){
                this.$store.commit('addService',{service:this.service.service, userId:userId, setSelected:true})
                if(this.activeMethod=="move"){
                   
                    this.$emit('handle-DropdownItem-Click','Yes')
                }
            },
            hide: function(){
                if(this.showDropdown) this.showDropdown = false;
                this.activeMethod = null;

            },
            handleserviceClick: function(method){
                this.activeMethod = method;
            },
        }
    }
})
})('<div v-if="(activeStep==1 && editing_this) || activeStep==2 " > <div :class="class_name"> <div class= "sidebar_service_details"> <p v-if="service.time && date">{{localStrings.sideCart.service.header.startTimeText}} <strong>{{dateString}}</strong> </p> </div> </div> </div>');
